import React from 'react';
import PropTypes from 'prop-types';

import { ChapterPage } from '../../partials';

export const ComplexLayoutsChapter = ({ name }) => (
  <ChapterPage title={name}>
    <p>This chapter goes into some complex layouts using flexbox.</p>

    <p>
      Some of these use the <code>flex</code> property, which allows you to
      specify how children should fill up the space inside of their container,
      by either expanding or shrinking.
    </p>
  </ChapterPage>
);

ComplexLayoutsChapter.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/chapters/ComplexLayoutsChapter.js